import React from "react";
import { bool, object } from "prop-types";
import InsightLogo from "resources/images/logo_insight_3.png";
import { scheduleContactCSMButtonDemoUrl } from "../helpers";

const ContactCSMSection = (props) => {
  const { isInsightUser, isAU, userData } = props;

  let rep = {};
  if (userData && userData.rep) {
    rep =
      userData.status === "free_trial" ? userData.rep.sdr : userData.rep.csm;
  }
  const noLongerEmployed = rep.noLongerEmployed !== 0;
  const repHasOwnTelephoneNumberAU = isAU && rep ? rep.telephoneNumber : null;
  const repExtension = noLongerEmployed ? "1" : rep.extension;
  // if rep is 304 (AM) or 296 (CSM), then it is a digital engagement
  const digitalEngagement = rep.userId === 304 || rep.userId === 296;

  const subscriber = userData && userData.status === "subscriber";
  const suspended = userData && userData.suspended;

  const repEmail = noLongerEmployed
    ? "sales@criteriacorp.com"
    : rep.emailAddress;

  const isFreeTrial = userData.status === "free_trial";

  const contactCSMButtonUtmParams = {
    content: isFreeTrial ? "free_trial_se" : "subscriber_csm",
    campaign: "global_bottom_support_icon",
    source: "platform",
    medium: userData?.companyAccountId,
  };

  const contactCSMButtonHrefSchedule = noLongerEmployed
    ? "https://resources.criteriacorp.com/exp-free-trial-demo-request"
    : scheduleContactCSMButtonDemoUrl(
        isFreeTrial,
        userData.rep,
        userData.numberOfEmployees,
        contactCSMButtonUtmParams
      );

  const getContactCSMButtonText = () => {
    let contactCSMButtonText;
    if (isInsightUser) {
      contactCSMButtonText = "Email Insight Support";
    } else if (subscriber) {
      contactCSMButtonText = "Book time with me";
    } else {
      contactCSMButtonText = "Schedule a Demo";
    }
    return contactCSMButtonText;
  };

  const contactCSMHeaderText =
    subscriber || suspended ? (
      <p>
        For strategy or best practice questions, email your CSM or book time
        directly on their calendar.
      </p>
    ) : null;

  return (
    <>
      {isInsightUser && (
        <div className="contact-csm-section d-flex align-items-center mb-2">
          <div className="mr-3">
            <img
              src={InsightLogo}
              height="45px"
              width="116px"
              alt="insight logo"
            />
          </div>
          <div>
            <a href="mailto: insight@criteriacorp.com">
              insight@criteriacorp.com
            </a>
            <p className="mb-0" style={{ color: "#53565A" }}>
              (877) 909-8378 x.300
            </p>
          </div>
        </div>
      )}
      {isAU && !digitalEngagement ? (
        <div className="contact-csm-section">
          {contactCSMHeaderText}
          <div className="d-flex align-items-center mb-2">
            <div
              className="csm-rep-photo mr-1 d-flex justify-content-center"
              style={{ flex: "0 0 113px" }}
            >
              <img
                src={`https://s3.amazonaws.com/criteria-static-web-assets/employees/${rep.firstName.toLowerCase()}_${rep.lastName.toLowerCase()}.jpg`}
                alt={`${rep.firstName} ${rep.lastName}`}
                className="rounded-circle"
                style={{
                  maxWidth: "80px",
                  maxHeight: "80px",
                  border: "2px solid #ECECEC",
                }}
              />
            </div>
            <div className="csm-contact-information">
              <div className="font-weight-bold">
                {rep.firstName} {rep.lastName}
              </div>
              <div style={{ color: "#53565A" }}>{rep.title}</div>
              <div>
                <a href={`mailto:${repEmail}`}>{repEmail}</a>
              </div>
              <div style={{ color: "#53565A" }}>
                {repHasOwnTelephoneNumberAU
                  ? `${rep.telephoneNumber}`
                  : `Australia: 1300 137 937 / New Zealand: 0800 003 218 / United
                  Kingdom: 0800 046 9690 / United States: 888 260 4639 / Other
                  Countries +61 7 3552 5700`}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!isInsightUser && !isAU && !digitalEngagement ? (
        <div className="contact-csm-section">
          {contactCSMHeaderText}
          <div className="d-flex align-items-center mb-2">
            <div
              className="csm-rep-photo mr-1 d-flex justify-content-center"
              style={{ flex: "0 0 113px" }}
            >
              <img
                src={`https://s3.amazonaws.com/criteria-static-web-assets/employees/${rep.firstName.toLowerCase()}_${rep.lastName.toLowerCase()}.jpg`}
                alt={`${rep.firstName} ${rep.lastName}`}
                className="rounded-circle"
                style={{
                  width: "80px",
                  height: "80px",
                  border: "2px solid #ECECEC",
                }}
              />
            </div>
            <div className="csm-contact-information" style={{ minWidth: "0" }}>
              <div style={{ fontWeight: "bold" }}>
                {rep.firstName} {rep.lastName}
              </div>
              <div style={{ color: "#53565A" }}>{rep.title}</div>
              <div>
                <a
                  href={`mailto:${repEmail}`}
                  style={{
                    wordWrap: "break-word",
                    display: "block",
                    whiteSpace: "normal",
                  }}
                >
                  {repEmail}
                </a>
              </div>
              <div style={{ color: "#53565A" }}>
                {rep.telephoneNumber
                  ? `${rep.telephoneNumber}`
                  : `(877) 909-8378 x.${repExtension}`}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {!digitalEngagement ? (
        <p className="mb-0">
          <a
            className="btn btn-primary w-100"
            name="SOBookingLink"
            href={
              isInsightUser
                ? "mailto: insight@criteriacorp.com"
                : contactCSMButtonHrefSchedule
            }
            target="_blank"
          >
            {getContactCSMButtonText()}
          </a>
        </p>
      ) : null}
    </>
  );
};

ContactCSMSection.propTypes = {
  isInsightUser: bool,
  isAU: bool,
  userData: object,
};

export default ContactCSMSection;
